import React from "react"
import {Box} from "@mui/material"
import ChartSwitcher from "./chart/chart-switcher"

const BalkenDiagrammWidget = ({value = []}) => {

    return (
        value && <Box height="100%">
            <ChartSwitcher
                chartType={"BAR"}
                data={value?.flatMap(({data}) => data)}
            />
        </Box>
    )
}

export default BalkenDiagrammWidget